export enum EthereumProviderKeyEnum {
  METAMASK = "Metamask",
  WALLET_CONNECT = "WalletConnect",
}

export type EthereumProviderKey = keyof typeof EthereumProviderKeyEnum
